<mat-sidenav-container autosize>
  <mat-sidenav [mode]="mobile ? 'over' : 'side'" [(opened)]="opened" fixedInViewport="true">
    <mat-nav-list>
      <mat-list-item *ngFor="let item of navItems" [routerLink]="item.routerLink" routerLinkActive="active-link"
        class="nav-item">
        <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
        <a matListItemTitle>
          {{ item.title | translate }}
        </a>
      </mat-list-item>
      <div class="bottomItems mobile-only">
        <mat-divider></mat-divider>
        <mat-list-item class="nav-item" disableRipple cdkFocusInitial>
          <mat-icon matListItemIcon>person</mat-icon>
          <a matListItemTitle>
            {{ userName}}
          </a>
        </mat-list-item>
        <mat-list-item class="nav-item" disableRipple>
          <mat-icon matListItemIcon>language</mat-icon>
          <a matListItemTitle>
            <mat-label>{{'header.language-label' | translate}}</mat-label>
            <mat-select panelWidth="fit-content" [(value)]="language.selectedLanguage" class="lang-select">
              <mat-option *ngFor="let lang of language.languages" [value]="lang">{{ lang }}</mat-option>
            </mat-select>
          </a>
        </mat-list-item>
        <mat-list-item class="nav-item" routerLink="/change-password">
          <mat-icon matListItemIcon>lock_reset</mat-icon>
          <a matListItemTitle>
            {{'header.change-password-button' | translate}}
          </a>
        </mat-list-item>
        <mat-list-item class="nav-item" routerLink="/logout">
          <mat-icon matListItemIcon>logout</mat-icon>
          <a matListItemTitle>
            {{'header.logout-button' | translate}}
          </a>
        </mat-list-item>
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
